import React, { useState, useEffect } from 'react';
import { array } from 'prop-types';

import useGetCurrentDevice from 'hooks/useGetCurrentDevice';
import useStyles from 'hooks/useStyles';

import GroupLink from '../GroupLink';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './GroupLinkList.scss';
import { isServerSide } from 'utils/common';

const GROUP_ITEM_SPACING = 20;

const calcGroupListTotalWidth = (isMobile, length) => {
  if (isServerSide() || !isMobile) return null;

  const groupItemWidth = window.innerWidth * 0.675 + GROUP_ITEM_SPACING;

  return groupItemWidth * length;
};

// eslint-disable-next-line no-unused-vars
function GroupLinkList({ list }) {
  useStyles(styles);

  const { isMobile } = useGetCurrentDevice();
  const [totalWidth, setTotalWidth] = useState(
    calcGroupListTotalWidth(isMobile, list.length),
  );

  useEffect(() => {
    const width = calcGroupListTotalWidth(isMobile, list.length);
    setTotalWidth(() => width);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  if (isServerSide()) return null;

  return (
    // TODO: wait Course Group Page
    <div className={styles.root}>
      <div style={{ width: totalWidth }} className={styles.content}>
        {list.map(({ key, title }) => (
          <GroupLink key={key} title={title} id={key} />
        ))}
      </div>
    </div>
  );
}

GroupLinkList.propTypes = {
  list: array.isRequired,
};

export default GroupLinkList;
